import React, { useEffect, useState } from "react";
import PageLayout from "../components/PageLayout";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { ClipboardText, ArrowRight } from "@phosphor-icons/react";

const STATUS_LABELS = { active: "Pending", won: "Won", lost: "Lost", withdrawn: "Withdrawn" };
const STATUS_STYLES = {
  active: "bg-amber-100 text-amber-900",
  won: "bg-emerald-100 text-emerald-900",
  lost: "bg-zinc-100 text-zinc-600",
  withdrawn: "bg-zinc-100 text-zinc-600",
};

export default function MyBids() {
  const [bids, setBids] = useState(null);
  useEffect(() => { api.get("/bids/mine").then(({ data }) => setBids(data)); }, []);

  return (
    <PageLayout>
      <div className="max-w-6xl">
        <div className="kicker">Appraiser</div>
        <h1 className="display-serif text-4xl sm:text-5xl mt-2">My bids.</h1>

        <div className="mt-8 grid gap-3">
          {bids === null ? <div className="text-zinc-500">Loading…</div> : bids.length === 0 ? (
            <div className="surface-card p-8 text-zinc-600">You haven&apos;t bid on anything yet.</div>
          ) : bids.map(b => (
            <Link key={b.bid_id} to={`/jobs/${b.job_id}`} data-testid={`my-bid-${b.bid_id}`}
              className="surface-card p-5 flex flex-col sm:flex-row sm:items-center gap-3 hover:-translate-y-0.5 transition-transform duration-200">
              <ClipboardText size={22} className="text-[#115E59]" weight="duotone" />
              <div className="flex-1">
                <div className="font-medium">{b.job?.address}, {b.job?.city}</div>
                <div className="text-xs text-zinc-500 mt-0.5">Total ${b.total_fee.toFixed(0)} • Min ${b.minimum_fee.toFixed(0)} • {b.add_ons.length} add-on{b.add_ons.length !== 1 ? "s" : ""}</div>
              </div>
              <span className={`chip ${STATUS_STYLES[b.status]}`}>{STATUS_LABELS[b.status]}</span>
              <ArrowRight size={16} className="text-zinc-400" />
            </Link>
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
